<template>
  <div>
    <!-- {{ _value }} -->
    <!-- {{ maxNumber }} -->
    <div v-if="mode === 'DESIGN'">
      <div class="design">
        <i class="el-icon-plus"></i>
      </div>
      <!-- <div  class="el-upload__tip">{{ placeholder }} {{ sizeTip }}</div> -->
    </div>
 
    <div v-else class="upload-container" :class="{'hide-upload':maxNumber===_value.length,'upload-container-has':_value.length>0}">
      <div v-if="!readerMode  || perm==='E'">
        <el-upload
          accept="image/*"
          action="#"
          :limit="maxNumber"
           :file-list="_value"
          with-credentials
          :auto-upload="true" 
          :multiple="maxNumber > 1"
          :data="uploadParams"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :http-request="uploadFile"
          :disabled="perm==='R'"
          class="upload-con">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }" class="upload-file">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                <i class="el-icon-download"></i>
              </span> -->
              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <!-- <div slot="tip" class="el-upload__tip">{{ placeholder }} {{ sizeTip }}</div> -->
        </el-upload>
      </div>
      <!-- 查看 -->
      <div v-else  class="look-upload hide-upload" >
        <el-upload
          v-if="_value.length>0"
          accept="image/*"
          action="#"
          :limit="maxNumber"
           :file-list="_value"
          with-credentials
          :auto-upload="true" 
          :multiple="maxNumber > 1"
          :data="uploadParams"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :http-request="uploadFile"
          class="upload-con">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }" class="upload-file">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins';
import {  downloadFileBlob } from '@/utils/index';
const qiniu = require('qiniu-js');
export default {
  mixins: [componentMinxins],
  name: 'ImageUpload',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '请选择图片',
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 1,
    },
    enableZip: {
      type: Boolean,
      default: true,
    },
    readerMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    sizeTip() {
      // return this.maxSize > 0 ? `| 每张图不超过${this.maxSize}MB` : '';
      return this.maxSize > 0 ? `` : '';
    },
    _value: {
      get: function () {
        return this.value;
      },
      set: function (e) {
        console.log('>>',e)
        this.$emit("input", e);
      },
    },
  },
  data() {
    return {
      disabled: false,
      dialogVisible:false,
      dialogImageUrl: '',
      uploadParams: {},
      QiniuToken:'',
    };
  },
  methods: {
       // 覆盖默认的上传行为
       requestUpload() {

       },
    beforeUpload(file) {
      const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
      if (alows.indexOf(file.type) === -1) {
        this.$message.warning('存在不支持的图片格式');
      } else if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`);
      } else {
        this.$api.qiniuToken().then(res => {
          if (res.code === 0) {
            this.QiniuToken = res.data
            this.uploadFile(file)
            // return true;
          }
        });
        
      }
      return false;
    },
    async uploadFile(file) {
      console.log('uploadFile>>',file)
			const putExtra = {
				fname: file.name,//文件原文件名
				params: {},//用来放置自定义变量
				mimeType: ["image/png", "image/jpeg", "image/gif"],//用来限定上传文件类型，指定null时自动判断文件类型。
			}
			const config = {
				useCdnDomain: true,//表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
			}
			const key = "oaWebPC/" + this.generateUUID();
			const observable = qiniu.upload(file, key, this.QiniuToken, putExtra, config)
			let that = this
			const subscription = observable.subscribe({
				next(res) {
					console.log('next>>', res)
          // that.$message.warning('网络错误，请重新上传')
				},
				error(err) {
          that.$message.warning('网络错误，请重新上传')
				},
				complete(res) {
						console.log('complete>>', res)
					console.log('https://fenxiao.muruji.com/' + res.key)
					let url = 'https://fenxiao.muruji.com/' + res.key
					let obj = {
						url,
            name:file.name,
            uid:file.uid
					}
					// console.log('obj', obj)
          that._value.push(obj); //成功过后手动将文件添加到展示列表里
          that.$emit('input', that._value);
					// that.fileList1.push(obj)
					// that.form.image = that.fileList1[that.fileList1.length - 1].url
					// that.$refs.form.clearValidate('image')
					// console.log(that.fileList1, '---')
				},
			})
        //上传文件的需要formdata类型;所以要转
        // let FormDatas = new FormData();
        // FormDatas.append('file', file);
        // console.log('uploadFile>>',file)
        // this.$api.uploadFiles(FormDatas).then(res => {
        // console.log('uploadFile', res);

        // if (res.code === 0) {
        //     let imageUrl = this.ImgHttps + res.data.url
        //     this._value.push(imageUrl); //成功过后手动将文件添加到展示列表里
        //     console.log("   {{_value}}",this._value)
        //     this.$emit('input', this._value);
        //   }
        // });
    },
    generateUUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				const r = (Math.random() * 16) | 0;
				const v = c === 'x' ? r : (r & 0x3) | 0x8;
				return v.toString(16);
			});
		},

    // 删除图片
    beforeRemove(file, fileList) {
      // const url = file.url
      // this.$emit('handleRemove', url)
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      // 删除数组对象中的file对象
      this._value.splice(this._value.indexOf(file), 1)
      // console.log(file, fileList);
    },
    // handlePictureCardPreview(file) {
    //   console.log(file);
    // },
    handleDownload(file) {
        //上传文件的需要formdata类型;所以要转
      let FormDatas = new FormData();
      FormDatas.append('name', file.name);
      // downLoadFileApi(FormDatas).then(res => {
      //   if (res.data) {
      //     downloadFileBlob(res.data,file.name)
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container{
  line-height: 1;
}
.upload-container-has{
  // margin-bottom: -10px;
}
.design {
  width: 64px;
  height: 64px;
  border: 1px solid #E3E6E5;
  border-radius: 4px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    // padding: 10px;
    font-size:24px;

    color: #E3E6E5;
    
  }
}
/deep/ .el-upload--picture-card {
  width: 64px;
  height: 64px;
  line-height: 1;
  border-radius: 4px;
  border-style: solid;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 8px 4px 0;
  .el-icon-plus{
    font-size: 24px;
    color: #c0ccda;
  }
}
/deep/ .el-upload-list--picture-card .el-upload-list__item{
    width: 64px;
    height: 64px;
    border-radius: 4px;
    margin: 4px 8px 4px 0;
    line-height: 1;
    transition:none;
    .upload-file{
      width: 62px;
      height: 62px;
      overflow: hidden;
    }
    .el-upload-list__item-thumbnail{
      object-fit: contain;
      display: block;
      width: 62px;
      height: 62px;
    }
  }
  .upload-con{
    display: flex;
    font-size: 0;
  }
  .hide-upload{
    line-height: 1;
    // margin-bottom: -10px;
    /deep/{
      .el-upload{
        display: none;
      }
    }
  }
  .look-upload{
    padding-bottom: 6px;
    // margin-bottom: 6px;
  }
</style>
